import { aurora } from './aurora.js';
export { aurora } from './aurora.js';
export { auroraUplift } from './auroraUplift.js';
import '@indeed/ifl-tokens';
import './utils.js';
import 'focus-visible';

const theme = aurora;

export { theme as default, theme };
